<div *ngIf="verificacionTracking != null && verificacionTracking != undefined && verificacionTracking.ExisteTracking">
    <app-header-language></app-header-language>
    <hr style="border-bottom: solid 1px black">
    <app-shipping-tracking-share [codigoTracking]="codigoTracking"></app-shipping-tracking-share>
</div>
<div *ngIf="verificacionTracking != null && verificacionTracking != undefined && !verificacionTracking.ExisteTracking"
    class="center">
    <h1>No existe el tracking</h1>
</div>